
<mat-form-field style="width:100%">
  <mat-label>{{ field.templateOptions.label }}</mat-label>
  <input matInput [matDatepicker]="picker1" [formControl]="formControl">
  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
  <mat-datepicker #picker1></mat-datepicker>
</mat-form-field>
